import * as types from '../mutation-types';
import { getOpenBidBySectionId, getBidSectionIsNeedFailBid } from '@/api/base';
import { Message } from 'element-gui';

const state = {
  openBidObj: {},
  endQrTime: 0, // 解密结束时间点
  serverTime: 0, // 解密服务器时间差
  startServerTime: 0, // 发起解密当前时间点
  isOut: false, // 放开解密
  isStop: false, // 解密时间停止
  finishDecryptObj: {
    // 解密结束
    isShow: false,
  },
  isThreeBidStatus: [], // 是否小于等于三家流标单位
  failBidTips: 0, // 是否小于等于三家流标单位弹框提示
};

const getters = {
  getStartServerTime: (state) => state.startServerTime,
  getBidObj: (state) => state.openBidObj,
  getEndOrTime: (state) => state.endQrTime,
  searchServerTime: (state) => state.serverTime,
  getIsOut: (state) => state.isOut,
  getIsStop: (state) => state.isStop,
  getFinishDecrypt: (state) => state.finishDecryptObj,
  getFailBidTips: (state) => state.failBidTips,
};

const actions = {
  // 记录各个时段小于等于三家流标单位的弹框提示
  async setFailBidTips({ commit }, obj) {
    commit(types.GET_FAILBIDTIPS_STATUS, obj);
  },
  // 查询是否有小于等于三家流标单位
  async getThreeBidStatus({ commit }, obj) {
    await getBidSectionIsNeedFailBid({
      bidSectionIds: obj.bidSectionIds,
      failBidNode: obj.failBidNode,
      openbidIds: obj.openbidIds,
    }).then((res) => {
      if (res.code == 200) {
        if (res.data.length) {
          res.data.forEach(function (item) {
            item.faildReason = '';
            item.bidResult = null;
          });
          commit(types.GET_GETTHREEBID_STATUS, res.data);
        } else {
          commit(types.GET_GETTHREEBID_STATUS, []);
        }
      } else {
        Message.error({
          message: res.data.msg,
          iconClass: 'el-icon-circle-cross1',
        });
      }
    });
  },
  // 发起解密当前时间点
  async setStartServerTime({ commit }, obj) {
    commit(types.GET_STARTTIME_STATUS, obj);
  },
  // 根据标段id获取全局开标状态
  async getOpenBidStatus({ commit }, obj) {
    await getOpenBidBySectionId({
      bidSectionId: obj.bidSectionId,
      stage: obj.stage,
    }).then((res) => {
      if (res.code == 200) {
        commit(types.GET_BID_STATUS, res.openBid);
        window.sessionStorage.setItem(
          'encryptionLevel',
          res.openBid.encryptionLevel ? res.openBid.encryptionLevel : '2'
        );
      } else {
        Message.error({
          message: res.data.msg,
          iconClass: 'el-icon-circle-cross1',
        });
      }
    });
  },
  // 解密结束时间
  async setEndOrTime({ commit }, obj) {
    commit(types.GET_ENDORTIME_STATUS, obj);
  },
  // 解密服务器时间差
  async setServerTime({ commit }, obj) {
    commit(types.GET_SERVERTIME_STATUS, obj);
  },
  // 解密时间开启时机
  async setIsOut({ commit }, obj) {
    commit(types.GET_ISOUT_STATUS, obj);
  },
  // 解密时间停止
  async setIsStop({ commit }, obj) {
    commit(types.GET_ISSTOP_STATUS, obj);
  },
  // 解密时间停止
  async setFinishDecrypt({ commit }, obj) {
    commit(types.GET_FINISHDECRYPT_STATUS, obj);
  },
};

const mutations = {
  [types.GET_FAILBIDTIPS_STATUS](state, obj) {
    state.failBidTips = obj;
  },
  [types.GET_GETTHREEBID_STATUS](state, obj) {
    state.isThreeBidStatus = obj;
  },
  [types.GET_BID_STATUS](state, obj) {
    state.openBidObj = obj;
  },
  [types.GET_ENDORTIME_STATUS](state, obj) {
    state.endQrTime = obj;
  },
  [types.GET_SERVERTIME_STATUS](state, obj) {
    state.serverTime = obj;
  },
  [types.GET_ISOUT_STATUS](state, obj) {
    state.isOut = obj;
  },
  [types.GET_ISSTOP_STATUS](state, obj) {
    state.isStop = obj;
  },
  [types.GET_FINISHDECRYPT_STATUS](state, obj) {
    state.finishDecryptObj = obj;
  },
  [types.GET_STARTTIME_STATUS](state, obj) {
    state.startServerTime = obj;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
